export default "dist/images/block-header-half.2315bdf.png";